import { MetadatiProtocolloGescorVO } from "./metadati-protocollo-gescorVO";

export class MetadatiCorrispondenzaArrivoVO {
  dataRicezione: string;

  metadatiProtocollo: MetadatiProtocolloGescorVO = new MetadatiProtocolloGescorVO();

  oggetto: string;

  riservata: boolean;

  // mittente: RecapitoVO = new RecapitoVO();
}
